/** Feedback 1 #6: admin-editable building types with capabilities. */
export type BuildingCapability = 'sales' | 'kiosk' | 'fleet_depot';
export type BuildingIconName = 'warehouse' | 'store' | 'office' | 'site' | 'other';

export const BUILDING_CAPABILITIES: { id: BuildingCapability; label: string; description: string }[] = [
  { id: 'sales', label: 'Has sales targets / POS', description: 'Till sales, sales targets and bonuses, sales widgets on Home and staffing-vs-sales.' },
  { id: 'kiosk', label: 'Has kiosk', description: 'Clock-in tablets can be registered here.' },
  { id: 'fleet_depot', label: 'Fleet depot', description: 'Vehicles can be based here and journeys start here.' },
];
export const BUILDING_ICONS: BuildingIconName[] = ['warehouse', 'store', 'office', 'site', 'other'];

export interface BuildingType {
  id: string;
  key: string;
  name: string;
  icon: BuildingIconName;
  capabilities: BuildingCapability[];
  position: number;
  retired_at: string | null;
  building_count: number;
}

/** Stable key for a new type, derived from its name (keys never change on rename). */
export function buildingTypeKey(name: string, taken: Iterable<string> = []): string {
  const base = name.toLowerCase().normalize('NFKD').replace(/[^\w\s-]/g, '').trim().replace(/[\s_]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 32) || 'type';
  const used = new Set(taken);
  let k = /^[a-z0-9]/.test(base) ? base : `t-${base}`;
  for (let i = 2; used.has(k); i++) k = `${base.slice(0, 30)}-${i}`;
  return k;
}

export function hasCapability(b: { capabilities?: readonly string[] | null } | null | undefined, cap: BuildingCapability): boolean {
  return Boolean(b?.capabilities?.includes(cap));
}
